<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 mx-auto">
                    <div class="text-center my-5">
                        <h1 class="display-4 fw-bold text-primary">Angebot anfordern</h1>
                        <div class="border-bottom border-primary mx-auto" style="width: 100px; margin-top: 15px;"></div>
                        <p class="lead mt-3">Erhalten Sie ein maßgeschneidertes Angebot für Ihr Unternehmen</p>
                    </div>

                    <div class="card mt-3 shadow-sm">
                        <div class="card-header bg-primary text-white">
                            <h3 class="mb-0">Ihre Anfrage</h3>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="form">
                                <p>Bitte geben Sie uns ein paar Informationen bekannt, damit wir Sie kontaktieren können.</p>

                                <div class="form-group mb-3">
                                    <label class="form-label fw-bold">Name</label>
                                    <input type="text" class="form-control" formControlName="name" appAutofocus>
                                </div>

                                <h5 class="mt-4 mb-3">Adresse</h5>
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group mb-3">
                                            <label class="form-label fw-bold">PLZ</label>
                                            <input type="number" class="form-control" formControlName="zip">
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group mb-3">
                                            <label class="form-label fw-bold">Ort</label>
                                            <input type="text" class="form-control" formControlName="city">
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group mb-3">
                                            <label class="form-label fw-bold">Straße</label>
                                            <input type="text" class="form-control" formControlName="street">
                                        </div>
                                    </div>
                                </div>

                                <h5 class="mt-4 mb-3">Nutzung</h5>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label fw-bold">Anzahl Standorte</label>
                                            <input type="number" class="form-control" min="1" formControlName="number_locations">
                                            <small class="text-muted">Für wie viele Standorte möchten Sie NoteRadar einsetzen?</small>
                                        </div>
                                    </div>
                                </div>

                                <h5 class="mt-4 mb-3">Kontaktdaten</h5>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label fw-bold">E-Mail</label>
                                            <input type="text" class="form-control" formControlName="email" [class.ng-invalid]="form.hasError('atLeastOneRequired')">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group mb-3">
                                            <label class="form-label fw-bold">Telefon</label>
                                            <input type="text" class="form-control" formControlName="phone" [class.ng-invalid]="form.hasError('atLeastOneRequired')">
                                        </div>
                                    </div>
                                </div>
                                <small *ngIf="form.hasError('atLeastOneRequired')" class="text-danger">
                                    {{form.getError('atLeastOneRequired').text}}
                                </small>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="requestOffer()">
                                <i class="fas fa-paper-plane mr-2"></i>Angebot anfordern
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
